import { render, staticRenderFns } from "./AlphaCsvReview.vue?vue&type=template&id=a24a40d2&scoped=true"
import script from "./AlphaCsvReview.vue?vue&type=script&lang=ts"
export * from "./AlphaCsvReview.vue?vue&type=script&lang=ts"
import style0 from "./AlphaCsvReview.vue?vue&type=style&index=0&id=a24a40d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24a40d2",
  null
  
)

export default component.exports